<mat-slide-toggle
  [checked]="value"
  [color]="color"
  [disableRipple]="disableRipple"
  [labelPosition]="labelPosition"
  (change)="onValueChange($event)">
  {{ label }}
</mat-slide-toggle>
<ng-content select="[info]"></ng-content>
<ng-content select="[validation]"></ng-content>